import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { IfOnline } from "../OnlineContext";
import { getAllRegFields } from "./RegistrationFields";
import { unescapeString } from "./fieldescaping";
import SecurityIcon from "@mui/icons-material/Security";
import React from "react";

const EventCardRegistrations = ({
  event,
  doc,
  canUserEditEvent,
  registrations,
}) => {
  const deadline = event.registrationDeadline
    ? new Date(event.registrationDeadline.iso)
    : undefined;
  const opening = event.registrationOpening
    ? new Date(event.registrationOpening.iso)
    : undefined;
  const now = new Date();
  const openForRegistration =
    event.openForRegistration &&
    (!deadline || deadline > now) &&
    (!opening || opening < now);
  const isArchived =
    new Date(
      event.endDate.getFullYear(),
      event.endDate.getMonth() + 1,
      event.endDate.getDate(),
      4,
      0,
      0,
    ) < now;
  const showRegistrationsTable =
    (canUserEditEvent() && openForRegistration) ||
    (registrations.length > 0 && !isArchived);
  const regCount = event.regCount || 0;
  const hadRegistrations = regCount > 0 && event.openForRegistration;

  return (
    <>
      {showRegistrationsTable && (
        <Typography variant="h6">Inschrijvingen</Typography>
      )}
      {hadRegistrations && isArchived && (
        <Typography variant="h6">
          {"Er " +
            (regCount === 1 ? "was " : "waren ") +
            regCount +
            " inschrijving" +
            (regCount !== 1 ? "en" : "")}
        </Typography>
      )}

      {showRegistrationsTable && (
        <IfOnline>
          <div className={"EventCard-tableContainer"}>
            <Table className={"EventCard-table"}>
              <TableHead>
                <TableRow>
                  <TableCell padding="none" style={{ paddingLeft: "8px" }} />
                  {!doc.get("teamRegistration") && <TableCell>Naam</TableCell>}
                  {getAllRegFields(doc, canUserEditEvent()).map(
                    ([field, personal]) => (
                      <TableCell align="right" key={field}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {unescapeString(field)}
                          {personal && (
                            <SecurityIcon
                              style={{ fontSize: 18, marginLeft: 6 }}
                            />
                          )}
                        </div>
                      </TableCell>
                    ),
                  )}{" "}
                </TableRow>
              </TableHead>
              <TableBody>
                {registrations.map((row, i) => (
                  <TableRow key={row.objectId}>
                    <TableCell padding="none" style={{ paddingLeft: "8px" }}>
                      {i + 1}.
                    </TableCell>
                    {!doc.get("teamRegistration") && (
                      <TableCell component="th" scope="row">
                        {row.user}
                      </TableCell>
                    )}
                    {getAllRegFields(doc, canUserEditEvent()).map(([field]) => (
                      <TableCell key={row.objectId + field} align="right">
                        {row.fields?.[field] || "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </IfOnline>
      )}
    </>
  );
};

export default EventCardRegistrations;
